/* istanbul ignore file */
import { array as codecArray, optional as codecOptional } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const UploadSubmissionAssignmentDataParser = 
/* #__PURE__ */ parsers.object([
    ['file', /* #__PURE__ */ codecOptional(/* #__PURE__ */ codecArray(parsers.file))],
]);
export class UploadSubmissionAssignmentData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return UploadSubmissionAssignmentDataParser.decode(input).map(res => new UploadSubmissionAssignmentData(res));
    }
    static unsafeDecode(input) {
        return UploadSubmissionAssignmentData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return UploadSubmissionAssignmentDataParser.encode(data);
    }
    static schema() {
        return UploadSubmissionAssignmentDataParser.schema();
    }
}
